import { call, put, all, takeLatest } from 'redux-saga/effects';

import { apiSimulador } from '~/services/api';

import { successSimulador, failureSimulador } from './actions';

function* requestSimulador({ payload }) {
	const { body, params } = payload;
	try {
		const resposta = yield call(
			apiSimulador.post,
			`simulador/${params}`,
			body
		);
		if (params === 'cliente') {
			yield put(
				successSimulador({
					lista: resposta.data[0].parcelas,
					valor: resposta.data[0].valor_liquido,
					show_credito: resposta.data[0].exibir_credito || false,
				})
			);
		} else {
			yield put(
				successSimulador({
					lista: resposta.data[0].parcelas,
					show_credito: resposta.data[0].exibir_credito || false,
					valor: 0,
				})
			);
		}
	} catch (error) {
		yield put(failureSimulador(error.response.status));
	}
}

export default all([
	takeLatest('@clientSimulador/REQUEST_SIMULADOR', requestSimulador),
]);
